import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f4b9e20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field-container" }
const _hoisted_2 = {
  key: 0,
  class: "field-name",
  for: "input-field-text"
}
const _hoisted_3 = ["readonly", "maxlength"]
const _hoisted_4 = { class: "advise" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'form-group': true,
      'input-is-invalid': !!_ctx.validation_message,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({
          'input-field': true,
          'input-not-empty': _ctx.text,
          'input-readonly': _ctx.readonly,
          'manual-focus': _ctx.manual_focus,
        })
      }, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          type: 'text',
          class: _normalizeClass({ 'text-field': true, 'not-editable': _ctx.not_editable }),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
          autocomplete: "off",
          readonly: _ctx.readonly,
          maxlength: _ctx.maxlength,
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.formatInput && _ctx.formatInput(...args))),
          onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
          onFocusout: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
        }, null, 42, _hoisted_3), [
          [_vModelDynamic, _ctx.text]
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!!_ctx.validation_message)
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: "exclamation-circle"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(_ctx.validation_message), 1)
    ])
  ], 2))
}